export default function HoverableItem({ item }: { item: any }) {
    return (
        <div className="shrink-0 cardWrapper relative mx-auto">
            <div className="shrink-0 w-[80%] aspect-[16/10] h-full mx-auto md:w-[168px] md:h-[105px] relative cardImage cursor-pointer shadow-lg rounded-xl" style={{ transformStyle: 'preserve-3d' }}>
                <img alt={item.imageAlt} src={item.imageSrc} className="card-side card-frontSide w-full h-full absolute rounded-xl" style={{ transformStyle: 'preserve-3d' }}></img>
                <img alt={item.imageAlt} src={item.imageBackSrc} className="card-side card-backSide w-full h-full absolute rounded-xl" style={{ transformStyle: 'preserve-3d' }}></img>
            </div>
        </div>
    )
};
